// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  console.log("Start of merchantPurchaseCustomeCode");
  // START OF MERCHANT CENTER CODE
  gtag("config", "G-MRVLDFXCCW");

  gtag("event", "purchase", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/thank_you",
    language: getLanguage(),
    page_title: "Checkout - Receipt",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "EnhancedEcommerce",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
    transaction_id: params.shopOrderId,
    tax: "0.0",
    shipping: params.shippingCharge,
    coupon: undefined,
    value: params.totalPrice,
    items: convertToMerchantParams(params.items),
  });

  gtag("event", "purchase", {
    send_to: ["AW-11459412052/j41sCJ-dt4UZENSAo9gq", "MC-DMD0QEYLN0"],
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: convertToMerchantParams(params.items),
  });

  gtag("event", "Completed Order", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/thank_you",
    language: getLanguage(),
    page_title: "Checkout - Receipt",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "EnhancedEcommerce",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Receipt Page", {
    page_location: params.currentLocation,
    page_path: "/checkout/thank_you",
    language: getLanguage(),
    page_title: "Checkout - Receipt",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "page_view", {
    page_location: params.currentLocation,
    page_path: "/checkout/thank_you",
    language: getLanguage(),
    page_title: "Checkout - Receipt",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Completed Order", {
    event_category: "EnhancedEcommerce",
    send_to: "G-SB9CPEYE8K",
  });
  gtag("event", "Viewed Checkout - Receipt Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });

  gtag("event", "page_view", {
    send_to: [
      "G-SB9CPEYE8K",
      "AW-11459412052/JvtxCKKdt4UZENSAo9gq",
      "MC-DMD0QEYLN0",
    ],
    page_path: "/checkout/thank_you",
    page_title: "Checkout - Receipt",
    page_location: params.currentLocation,
    ignore_referrer: "true",
  });
  // END OF MERCHANT CENTER CODE
  console.log("End of merchantPurchaseCustomeCode");
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.error("Error in triggering merchants add Payment info script: ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  gtag("config", "G-MRVLDFXCCW");
  gtag("event", "add_payment_info", {
    send_to: ["AW-11459412052/CcJ4CLGdt4UZENSAo9gq"],
    currency: params.currency,
    total: params.totalPrice,
    ignore_referrer: "true",
  });

  gtag("event", "Viewed Checkout - Shipping Page", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/shipping",
    language: getLanguage(),
    page_title: "Checkout - Shipping",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });
  gtag("event", "Viewed Checkout - Processing Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });

  gtag("event", "page_view", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/processing",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/processing",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "page_view", {
    page_location: params.currentLocation,
    page_path: "/checkout/processing?completed=true",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    page_location: params.currentLocation,
    page_path: "/checkout/processing?completed=true",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "page_view", {
    page_location: params.currentLocation,
    page_path: "/checkout/processing?completed=true",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    page_location: params.currentLocation,
    page_path: "/checkout/processing?completed=true",
    language: getLanguage(),
    page_title: "Checkout - Processing",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  // paste the snippet out here
  gtag("event", "page_view", {
    send_to: [
      "G-SB9CPEYE8K",
      "AW-11459412052/JvtxCKKdt4UZENSAo9gq",
      "MC-DMD0QEYLN0",
    ],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: params.currentLocation,
    ignore_referrer: true,
  });

  gtag("event", "page_view", {
    send_to: [
      "G-SB9CPEYE8K",
      "AW-11459412052/JvtxCKKdt4UZENSAo9gq",
      "MC-DMD0QEYLN0",
    ],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: params.currentLocation,
    ignore_referrer: true,
  });

  gtag("event", "page_view", {
    send_to: [
      "G-SB9CPEYE8K",
      "AW-11459412052/JvtxCKKdt4UZENSAo9gq",
      "MC-DMD0QEYLN0",
    ],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: params.currentLocation,
    ignore_referrer: "true",
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });
  gtag("event", "Viewed Checkout - Shipping Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });

  console.log("End of merchantAddPaymentInfoCustomCode");
}
// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.error(
      "Error in triggering merchants initiate checkout script: ",
      e
    );
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  gtag("event", "begin_checkout", {
    send_to: ["AW-11459412052/nYVRCK6dt4UZENSAo9gq"],
    value: params.totalPrice,
    currency: params.currency,
    items: convertToMerchantParams(params.items),
    ignore_referrer: "true",
  });

  console.log("begin_checkout");
  gtag("event", "begin_checkout", {
    currency: params.currency,
    page_location: params.currentLocation,
    language: getLanguage(),
    page_title: "Checkout - Binks",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "EnhancedEcommerce",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
    checkout_step: "1",
    items: convertToMerchantParams(params.items),
  });

  gtag("event", "page_view", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/contact_information",
    language: getLanguage(),
    page_title: "Checkout - Contact Information",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Contact Information Page", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/contact_information",
    language: getLanguage(),
    page_title: "Checkout - Contact Information",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "page_view", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/contact_information",
    language: getLanguage(),
    page_title: "Checkout - Contact Information",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Contact Information Page", {
    currency: params.currency,
    page_location: params.currentLocation,
    page_path: "/checkout/contact_information",
    language: getLanguage(),
    page_title: "Checkout - Contact Information",
    screen_resolution: getScreenResolution(),
    client_id: getGAClientIDfromMeasurementID(),
    event_category: "All",
    value: "0",
    allow_display_features: true,
    allow_ad_personalization_signals: true,
    cookie_domain: "getbinks.com",
    cookie_expires: 63072000,
    cookie_flags: "",
    cookie_path: "/",
    cookie_update: true,
    is_legacy_converted: true,
    send_to: ["G-MRVLDFXCCW"],
  });

  gtag("event", "Viewed Checkout - Shipping Page", {
    event_category: "All",
    value: 0,
    send_to: "G-SB9CPEYE8K",
  });

  gtag("event", "Started Order", {
    event_category: "EnhancedEcommerce",
    send_to: "G-SB9CPEYE8K",
  });

  // paste the snippet out here
  gtag("event", "page_view", {
    send_to: [
      "G-SB9CPEYE8K",
      "AW-11459412052/JvtxCKKdt4UZENSAo9gq",
      "MC-DMD0QEYLN0",
    ],
    page_path: params.currentLocation,
    page_title: "Checkout - Contact Information",
    page_location: params.currentLocation,
    ignore_referrer: true,
  });

  console.log("End of merchantInitiateCheckoutCustomCode");
}

function getLanguage() {
  return "en-gb";
}

function getScreenResolution() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  return screenHeight + "x" + screenWidth;
}

function getGAClientIDfromMeasurementID() {
  try {
    var match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)"),
      raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
      match = raw.match(/(\d+\.\d+)$/);
    }
    return match ? match[1] : null;
  } catch (e) {
    console.log("Exception: unable to get GA clientId");
  }
  return null;
}

function convertToMerchantParams(items) {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
    };
  });
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------
